import './promise-extends';
import fetchClass from './fetchClass';
import { Toast } from 'antd-mobile';
import { pipeline } from '@/utils/index';
import { encrypt, decrypt } from './fetchCrypto';

// 判断是安卓还是ios 0:android  1:ios -1:错误
const _getSystem = () => {
  const ua = navigator.userAgent;
  if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
    return 0;
  }
  if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    return 1;
  }
  return -1;
};
// const BASE_URL = 'https://gateway-test.suixingpay.com';
const BASE_URL = '/api/';

const fetchInstance = new fetchClass();

fetchInstance.defaults.baseURL = BASE_URL;
fetchInstance.defaults.timeout = 1000 * 60;

/**
 * 请求拦截
 */
fetchInstance.instance.interceptors.request.use(
  cfg => {
    console.log('cfg', cfg);
    const token = window.sessionStorage['xlm-token'];
    // const token = 'e5a3eeeb0b4f9b4d3c60c901e6dfcc48';
    if (token) cfg.headers.common['TOKEN'] = token;

    const version = window.sessionStorage['xlm-version'];
    if (version) cfg.headers.common['APP-VERSION'] = version;

    const userId = window.sessionStorage['xlm-userId'];
    // const userId = 'S0000000000000006577';
    if (userId) cfg.headers.common['USER_ID'] = userId;
    cfg.headers.common['PHONE-PLATFORM'] =
      _getSystem() === 0 ? 'android' : _getSystem() === 1 ? 'ios' : '';

    if (cfg.url.indexOf('sendCodeV12885521') > -1) {
      return pipeline(cfg, encrypt);
    } else {
      return cfg;
    }
  },
  error => {
    return Promise.reject(error);
  },
);

/**
 * 响应拦截
 */
fetchInstance.instance.interceptors.response.use(
  cfg => {
    console.log('cfgresponse', cfg);
    const { config, data } = cfg;
    if (config.url.indexOf('sendCodeV12885521') > -1) {
      const new_cfg = decrypt(cfg);
      console.log('new_cfg', new_cfg);
      return new_cfg;
    } else {
      return cfg;
    }
  },
  error => {
    window.error__ = error;
    const { config = {}, message = {} } = error;
    const { errorTip = '' } = config;
    if (message.canceled) return;
    const url = config.url || '';
    let response = {};
    if (url.indexOf('sendCodeV12885521') > -1) {
      response = {
        ...error?.response,
        data: decrypt(error.response),
      };
    } else {
      response = error.response || {};
    }

    if (errorTip) {
      // Toast.fail(errorTip, 2);
    } else if (errorTip === false) {
    } else if (error.toString().indexOf('timeout') > -1) {
      Toast.info('请求超时！', 2);
    } else if (error.message === 'Network Error') {
      Toast.info('网络异常，请稍后重试', 2);
    } else if (response.status === 500) {
      Toast.info(response.data);
    } else if (typeof response.data === 'string') {
      Toast.info(response.data, 2);
    } else if (response.data && response.data.message) {
      Toast.info(response.data.message, 2);
    } else {
      Toast.info('请求失败', 2);
    }
    return Promise.reject(error);
  },
);

export default fetchInstance;
